import { render } from "./NotificationListView.vue?vue&type=template&id=2c20039a&scoped=true&ts=true"
import script from "./NotificationListView.vue?vue&type=script&lang=ts"
export * from "./NotificationListView.vue?vue&type=script&lang=ts"

import "./NotificationListView.vue?vue&type=style&index=0&id=2c20039a&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c20039a"]])

export default __exports__